import type { ReactNode } from 'react'

interface HomePrimaryGridProps {
  children: ReactNode
}

export function HomePrimaryGrid({ children }: HomePrimaryGridProps) {
  return <div className="home-primary-grid">{children}</div>
}
